import { FORGOT_PASSWORD_STATE } from './constants'

export const getAccountExist = state => state[FORGOT_PASSWORD_STATE].accountExist
